import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHandRock,
    faHardHat,
    faMountain,
} from "@fortawesome/free-solid-svg-icons";

const features = [
    {
        icon: faHandRock,
        title: "What specializations are available in Geological Engineering?",
        desc: "Our program offers specializations in mineral exploration, hydrogeology, geotechnical engineering, and environmental geology, allowing students to tailor their education to their career interests.",
    },
    {
        icon: faHardHat,
        title: "What career opportunities exist for graduates?",
        desc: "Graduates find rewarding careers in mining, oil and gas, environmental consulting, construction, government agencies, and research institutions with competitive salaries and opportunities for fieldwork worldwide.",
    },
    {
        icon: faMountain,
        title: "How much fieldwork is involved in the program?",
        desc: "Our curriculum balances classroom learning with extensive field experiences, including mapping exercises, site investigations, and a capstone field camp that provides hands-on training in real-world geological settings.",
    },
];

const FeaturedItem = ({ feature }) => {
    return (
        <div className="flex items-start mb-6 last:mb-0">
            <div className="bg-blue-600 text-white min-w-[40px] h-10 rounded-xl text-base flex justify-center items-center mr-3 shrink-0">
                <FontAwesomeIcon icon={feature.icon} />
            </div>
            <div>
                <h5 className="text-lg font-bold mb-2">{feature.title}</h5>
                <p className="text-sm md:text-base font-light leading-relaxed text-gray-700 dark:text-gray-300">
                    {feature.desc}
                </p>
            </div>
        </div>
    );
};

FeaturedItem.propTypes = {
    feature: PropTypes.object.isRequired,
};

const HowWeHelp = () => {
    return (
        <section className="py-10 md:py-20 bg-white dark:bg-[#0b1727] text-zinc-900 dark:text-white relative overflow-hidden z-10">
            <div className="container px-4 mx-auto">
                <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 text-center">
                        <div className="mb-6">
                            <h1 className="text-2xl md:text-3xl font-bold leading-tight mb-3">
                                Shaping Earth's Future Through Engineering
                            </h1>
                            <p className="text-base md:text-lg opacity-80 leading-6 max-w-2xl mx-auto">
                                Geological engineering offers unique opportunities at the intersection of earth sciences and engineering principles. Discover how this field can lead to impactful careers in resource development, environmental protection, and infrastructure design. While many engineering disciplines exist, geological engineering stands out with its focus on Earth's materials, processes, and hazards.
                            </p>
                        </div>
                    </div>

                    <div className="col-span-12 lg:col-span-6 text-center mb-6 lg:mb-0">
                        <div
                            className="bg-top bg-no-repeat bg-cover rounded-xl h-64 md:h-[500px] w-full shadow-lg"
                            style={{
                                backgroundImage:
                                    "url(https://i0.wp.com/geologyscience.com/wp-content/uploads/2023/02/Engineering-Geology-for-Construction.jpeg?fit=1000%2C696&ssl=1)",
                            }}
                        />
                    </div>

                    <div className="col-span-12 lg:col-span-6 flex flex-col justify-center xl:pl-6">
                        {features.map((feature, i) => (
                            <FeaturedItem feature={feature} key={i} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowWeHelp;
